import {
  FormattedNumberInput,
  type FormattedNumberInputProps,
} from "./formatted-number-input";

export const PercentInput = (props: FormattedNumberInputProps) => {
  return <FormattedNumberInput rightIcon="%" {...props} />;
};
